import React, { useEffect, useState } from "react";
import { BarChart } from "@mui/x-charts/BarChart";
import { chartsTooltipClasses } from "@mui/x-charts";

import { Colors } from "../../config";

const VerticalBarChart = ({ xdata = [], series = [], ...props }) => {
  const [height, setHeight] = useState(350);

  useEffect(() => {
    const updateFontSize = () => {
      if (window.innerWidth >= 2560) {
        setHeight(465);
      } else if (window.innerWidth < 2560 && window.innerWidth >= 2400) {
        setHeight(437);
      } else if (window.innerWidth < 2400 && window.innerWidth >= 2133) {
        setHeight(388);
      } else if (window.innerWidth < 2133 && window.innerWidth >= 1920) {
        setHeight(350);
      } else if (window.innerWidth < 1920 && window.innerWidth >= 1745) {
        setHeight(317);
      } else if (window.innerWidth < 1745 && window.innerWidth >= 1536) {
        setHeight(278);
      } else if (window.innerWidth < 1536 && window.innerWidth >= 1280) {
        setHeight(232);
      } else {
        setHeight(350);
      }
    };
    updateFontSize();
    window.addEventListener("resize", updateFontSize);

    return () => window.removeEventListener("resize", updateFontSize);
  }, []);

  const colors = ["#54aea1", "#73a59e", "#6dc6f3", "#c3d8d5", "#d4fdf7"];

  return (
    <BarChart
      skipAnimation={false}
      height={height * 0.9}
      grid={{ horizontal: true }}
      yAxis={[
        {
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.875em",
            fontWeight: "600",
            display: "none",
          },
        },
      ]}
      xAxis={[
        {
          data: xdata,
          disableTicks: true,
          disableLine: true,
          tickLabelStyle: {
            fontSize: "0.875em",
            fontWeight: "600",
            // display: "none",
          },
        },
      ]}
      series={series}
      slotProps={{
        bar: (index) => ({
          style: {
            fill: colors[index.dataIndex] || Colors.main,
            stroke: Colors.main,
            strokeWidth: 1,
            clipPath: "inset(0 0 0 0 round 5px)",
          },
        }),
        tooltip: {
          sx: {
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.valueCell}`]:
              {
                fontSize: height / 16,
              },
            [`&.${chartsTooltipClasses.root} .${chartsTooltipClasses.labelCell}`]:
              {
                fontSize: height / 18,
              },
          },
        },
      }}
      hideLegend={true}
      margin={{ top: 0, right: 0, bottom: 0, left: -40 }}
      tooltip={{ trigger: "item" }}
      {...props}
    />
  );
};

export default VerticalBarChart;
